import { DividerSchema } from '@/views/sports/components/Divider/styles/Divider.styles';

export const dividerStyles: DividerSchema = {
  boxWrapper: {
    borderColor: 'blackAlpha.400',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  },
};
